<template>
  <div>
    <div class="no-order">
      <div class="img">
        <img :src="img" alt />
      </div>
      <p>{{text}}</p>
      <button v-if="btnFlag" @click="$router.push('/home')">去逛逛</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        
    };
  },
  props:{
     btnFlag:Boolean,
     text:String,
     img:String 
  }
};
</script>

<style lang="less" scoped>
.no-order {
  text-align: center;
  margin-top: 145px;
  .img {
    width: 216px;
    height: 223px;
    margin: 0 auto;
    img{
      width: 100%;
      height: 100%;
    }
  }
  p {
    color: #666;
    font-size: 26px;
    margin: 30px 0;
  }
  button {
      width: 270px;
      height: 90px;
      border-radius: 10px;
      background: #ff9900;
      color: #fff;
      border:none;
      font-size: 32px;
  }
}
</style>